import { FileUploaderFactory } from "@core/lib/file-uploader";


export class SimpleUploaderJobFactoryProvider implements angular.IServiceProvider {
    constructor() { }

    public $get = function () {
        return FileUploaderFactory.createSimpleUploaderJob;
    }
}

export class ProcessiveUploaderJobFactoryProvider implements angular.IServiceProvider {
    constructor() { }

    public $get = function () {
        return FileUploaderFactory.createProcessiveUploaderJob;
    }
}